import { Theme } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';

// ----------------------------------------------------------------------

export function tabs(theme: Theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: theme.palette.text.primary,
        },
        scrollButtons: {
          width: 43,
          borderRadius: '50%',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          // padding: 0,
          opacity: 1,
          minWidth: 43,
          minHeight: 38,
          padding: '6px 12px',
          fontWeight: theme.typography.fontWeightSemiBold,
          // '&:first-of-type': {
          //   paddingLeft: '0px',
          // },
          // '&:last-of-type': {
          //   paddingRight: '0px',
          // },
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(2.5),
            [theme.breakpoints.up('sm')]: {
              marginRight: theme.spacing(3.5),
            },
          },
          [`&:not(.${tabClasses.selected})`]: {
            color: theme.palette.text.secondary,
          },
          // Adjust tabs with icons
          '&.MuiTab-iconPositionEnd': {
            minHeight: 36,
            padding: '4px 12px',
          },
        },
      },
    },
  };
}
